/**
 * Etiqueta corta del marcador en los mapas: SS / WS / PS.
 *
 * Vivía duplicada en tres pantallas (Suelo, Locations y —con el nombre del
 * sensor en su lugar— el Dashboard). En el Dashboard eso dejaba el IMEI
 * completo dentro de un círculo de 32 px: un número de quince dígitos
 * desbordado sobre el mapa, en vez de la burbuja limpia del resto de la
 * plataforma. Una sola función evita que la cuarta copia vuelva a divergir.
 */
export function markerLabel(type?: string): 'SS' | 'WS' | 'PS' {
  if (type === 'weather') return 'WS';
  if (type === 'pest') return 'PS';
  return 'SS';
}
